import { useEffect, useState } from "react";
import { getPaymentStatus } from "../lib/api";

const MAX_POLLS = 8;
const POLL_MS = 2000;

/**
 * Polls the server for a Stripe Checkout session's payment status.
 * Returns { state: "checking" | "paid" | "pending" | "error", amount }.
 * Automatically stops polling on unmount or once a terminal state is reached.
 */
export function usePaymentStatus(sessionId) {
  const [state, setState] = useState("checking");
  const [amount, setAmount] = useState(null);
  const [kind, setKind] = useState("deposit");

  useEffect(() => {
    if (!sessionId) {
      setState("error");
      return undefined;
    }
    let cancelled = false;
    let timer;

    const attempt = async (n) => {
      try {
        const data = await getPaymentStatus(sessionId);
        if (cancelled) return;
        if (data.amount != null) setAmount(data.amount);
        if (data.kind) setKind(data.kind);
        if (data.payment_status === "paid") return setState("paid");
        if (["failed", "expired"].includes(data.payment_status)) return setState("error");
        if (n >= MAX_POLLS) return setState("pending");
        timer = setTimeout(() => attempt(n + 1), POLL_MS);
      } catch (e) {
        if (cancelled) return;
        if (n >= MAX_POLLS) return setState("error");
        timer = setTimeout(() => attempt(n + 1), POLL_MS);
      }
    };

    attempt(0);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [sessionId]);

  return { state, amount, kind };
}
